<template>
    <div>
        <img class="recruit-bannerImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-banner.png" alt="">
        <div class="recruit-banner">
            <div class="recruit-banner-title">智能教学解决方案</div>
            <div class="recruit-banner-title2">覆盖教育机构全部经营环节</div>
            <div class="recruit-banner-title2" style="margin-bottom: 80px;">提供全方位解决方案</div>
            <div class="im-bannerInfo-BtnBox">
                <div @click="gowe" class="im-bannerInfo-Btn">了解更多</div>
                <div @click="popshow = true" class="im-bannerInfo-Btn2">试用</div>
            </div>
        </div>
        <div class="recruit-cont-box">
            <div class="recruit-cont-box-l">
                <img style="margin-right: 170px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-lp.png" alt="">
            </div>
            <div class="recruit-cont-box-r">
                <div class="recruit-cont-box-title">课前备课</div>
                <div class="recruit-cont-box-title2">智能备课，轻松三步搞定</div>
                <div class="recruit-cont-box-cbg" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;width: 80px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-lp-t1.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title">选择章节</div>
                        <div class="recruit-cont-box-cbg-title2">选择授课章节，系统会自动显示该章节相关资源。</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg" >
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;width: 80px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-lp-t2.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title">选择资源</div>
                        <div class="recruit-cont-box-cbg-title2">查看并选择需要的课程资源，包括课件、测试、讲义等。</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg" >
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;width: 80px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-lp-t3.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title">课例预览</div>
                        <div class="recruit-cont-box-cbg-title2">教师预览课例，备课完成</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="down-arrow">
            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/down-arrow.png" alt="">
        </div>
        <div class="recruit-cont-box">
            <div class="recruit-cont-box-l">
                <img style="margin-right: 253px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-interaction.png" alt="">
            </div>
            <div class="recruit-cont-box-r">
                <div class="recruit-cont-box-title">课堂互动</div>
                <div class="recruit-cont-box-title2">提升课堂效率，活跃课堂气氛</div>
                <div class="recruit-cont-box-cbg" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">多种互动工具帮助提升课堂效率，提升学习兴趣，活</div>
                        <div class="recruit-cont-box-cbg-title2">跃课堂气氛，实现课堂实时记录、教师第一时间掌握</div>
                        <div class="recruit-cont-box-cbg-title2">学生学习情况</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="down-arrow">
            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/down-arrow.png" alt="">
        </div>
        <div class="recruit-cont-box" style="justify-content: flex-start">
            <div class="recruit-cont-box-l" >
                <img style="margin-right: 223px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-zx.png" alt="">
            </div>
            <div class="recruit-cont-box-r">
                <div class="recruit-cont-box-title">知新打卡</div>
                <div class="recruit-cont-box-title2">督学营销新模式</div>
                <div class="recruit-cont-box-cbg recruit-cont-box-dp" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 32px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-hook.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">”精准感知，新营销”，知新打卡旨在为教育行业提供</div>
                        <div class="recruit-cont-box-cbg-title2">督学新营销解决方案。</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg recruit-cont-box-dp" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 32px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-hook.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">课程作业  在线打卡  点评互动 </div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg recruit-cont-box-dp" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 32px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-hook.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">智能测评  口碑营销</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="down-arrow">
            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/down-arrow.png" alt="">
        </div>
        <div class="recruit-cont-box">
            <div class="recruit-cont-box-l">
                <img style="margin-right: 223px;margin-bottom: 30px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-test.png" alt="">
            </div>
            <div class="recruit-cont-box-r">
                <div class="recruit-cont-box-title">测评</div>
                <div class="recruit-cont-box-title2">多维分析数据，助力精准教学</div>
                <div class="recruit-cont-box-cbg" style="margin-top: 32px;">
                    <div class="recruit-cont-box-cbg-r" style="width: 400px;">
                        <div class="recruit-cont-box-cbg-title2">采集平时考试、作业练习中的过程性数据及终结数据，进</div>
                        <div class="recruit-cont-box-cbg-title2">行多维度分析，推送测评分析报告及提分策略，同时为学</div>
                        <div class="recruit-cont-box-cbg-title2">员制定个性错题集，有效辅助教师评价、教研反思、习题</div>
                        <div class="recruit-cont-box-cbg-title2">课讲评、学生个性化辅导。</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="popshow" class="pop-bg">
            <div class="pop">
                <img class="pop-logo" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/popup-t1.png" alt="">
                <div class="pop-title">产品试用请联系</div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                        <img class="pop-logo2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/popup-t2.png" alt="">
                        <div>手机号：</div>
                    </div>
                    <div class="pop-title2-box-r">15900622304</div>
                </div>
                <div class="pop-title2-box" style="margin-bottom: 38px;">
                    <div class="pop-title2-box-l">
                    </div>
                    <div class="pop-title2-box-r">18862561723</div>
                </div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                        <img class="pop-logo2" style="width: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/mailbox.png" alt="">
                        <div>邮箱：</div>
                    </div>
                    <div class="pop-title2-box-r">jenny.wang@unishining.com</div>
                </div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                    </div>
                    <div class="pop-title2-box-r">Diana.wu@unishining.com</div>
                </div>
                <div @click="popshow = false" class="pop-out">知道了</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "education-recruit",
        data:vm=>{
            return{
                popshow:false
            }
        },
        methods:{
            gowe(){
                this.$router.push('/we')
            },
        }
    }
</script>

<style lang="less" scoped>
    html{
        overflow-x:hidden;
    }
    .recruit-bannerImg{
        position: absolute;
        right: 0px;
        top: 61px;
        width: 985px;
    }
    .recruit-banner{
        position: relative;
        z-index: 1;
        margin: 7px auto 240px auto;
        width: 1200px;
        box-sizing: border-box;
        padding-top: 80px;
        .recruit-banner-title{
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 37px;
        }
        .recruit-banner-title2{
            font-size: 28px;
            font-weight: 300;
            margin-bottom: 5px;
        }
        .im-bannerInfo-BtnBox{
            display: flex;
            align-items: center;
            .im-bannerInfo-Btn{
                font-size: 16px;
                color: #636363;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 161px;
                height: 47px;
                border: 1px solid #313131;
                cursor: pointer;
            }
            .im-bannerInfo-Btn2{
                width: 161px;
                height: 47px;
                border: 1px solid #313131;
                background: #1B1B1B;
                font-size: 16px;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 20px;
                cursor: pointer;
            }
        }
    }
    .recruit-cont-box{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        .recruit-cont-box-title{
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 20px;
        }
        .recruit-cont-box-title2{
            font-size: 20px;
            font-weight: 300;
        }
        .recruit-cont-box-cbg{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 50px;
            .recruit-cont-box-cbg-title{
                font-size: 20px;
                margin-bottom: 13px;
            }
            .recruit-cont-box-cbg-title2{
                color: #636363;
                font-size: 14px;
            }
            .recruit-cont-box-cbg-r{
                width: 350px;
            }
        }
        .recruit-cont-box-dp{
            display: flex;
            align-items: flex-start;
            .recruit-cont-box-cbg-l{
                display: flex;
                align-items: flex-start;
            }
        }
        .recruit-cont-box-dp2{
            display: flex;
            align-items: flex-start;
            .recruit-cont-box-cbg-l{
                display: flex;
                align-items: flex-start;
            }
        }
        .recruit-cont-box-r{

        }
    }
    .down-arrow{
        width: 1200px;
        margin: 70px auto;
        text-align: center;
    }
    .pop-bg{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 99999;
        background: rgba(0,0,0,.5);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .pop{
            width: 395px;
            height: 502px;
            background: #FFFFFF;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .pop-logo{
                margin-bottom: 17px;
            }
            .pop-title{
                font-size: 20px;
                color: #000000;
                margin-bottom: 55px;
            }
            .pop-title2-box{
                display: flex;
                width: 350px;
                .pop-title2-box-l{
                    width: 96px;
                    font-size: 16px;
                    display: flex;
                    align-items: center;
                    .pop-logo2{
                        margin-right: 11px;
                    }
                }
                .pop-title2-box-r{
                    color: #B10515;
                    font-size: 18px;
                }
            }
            .pop-out{
                width: 172px;
                height: 45px;
                background: #B10515;
                border-radius: 23px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                font-size: 16px;
                cursor: pointer;
                margin-top: 70px;
            }
        }
    }
</style>